import React, { useState } from 'react'
import Logo from '../../assets/Mask_group.png'
import KpmgLogo from '../../assets/KPMG_white_logo.svg'
import { FaArrowTrendUp } from "react-icons/fa6";
import { GiNetworkBars } from "react-icons/gi";
import { CiClock2 } from "react-icons/ci";
import waves from '../../assets/framer/waves.png'
import { IoIosCheckbox } from "react-icons/io";
import { ImLoop } from "react-icons/im";
import image1 from '../../assets/framer/1.png'
import image2 from '../../assets/framer/2.png'
import image3 from '../../assets/framer/3.png'
import image4 from '../../assets/framer/4.png'
import image5 from '../../assets/framer/5.png'
import image6 from '../../assets/framer/6.png'
import { SiTicktick } from "react-icons/si"
import { HiX } from "react-icons/hi"
import {TrendingUp, Users, CheckSquare} from 'lucide-react'

import { ChevronDown, ChevronUp } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';



const LandingPage = () => {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState({});
  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  };

  const faqData = [
    {
      question: "What Makes LLMINATE Unique ?",
      answer: "LLMINATE combines real-time insights, seamless integrations and powerful optimization tools all in one platform."
    },
    {
      question: "Can I customize LLMINATE to match my brand ?",
      answer: "Yes, you can customize test configurations and strategies to align with your brand and goals."
    },
    {
      question: "How does LLMINATE help with AI Testing ?",
      answer: "LLMINATE allows you to test AI models, identify issues in real-time, and optimize your AI for better performance, all in one platform"
    },
    {
      question: "Does LLMINATE offer detailed failure reports ?",
      answer: "Absolutely, LLMINATE provides in-depth failure reports, highlighting what went wrong and where your AI needs improvement"
    },
    {
      question: "Can I run tests on multiple AI models at once ?",
      answer: "Yes, LLMINATE allows you to compare and test different models side by side to get detailed insights on performance."
    }
  ];
  
  
  return (
    <div className='text-white flex flex-col bg-black relative max-w-[100vw] h-auto'>
      <div className='fixed top-0 left-0  bg-[rgba(0,0,0,0.5)] bg-opacity-30 w-full flex flex-row justify-center items-center z-50'>
       <div className='w-[75%] flex flex-row justify-between items-center'>
        <div className='flex flex-col items-start justify-end gap-3 m-4 mb-0'>
          <img src={KpmgLogo} alt='KPMG' className='h-8 w-auto cursor-pointer'/>
          <p className='text-sm text-white font-bold mb-4 cursor-pointer'>AI Security Posture Scanner</p>
        </div>
        <div className='m-4 flex flex-row gap-9 mr-8 text-gray-400 text-lg'>
          {/* <button className='cursor-pointer'>
            Features
          </button>
          <button className='cursor-pointer'>
            Contact
          </button> */}
          {/* <button className='cursor-pointer'>
            Login
          </button> */}
          <button className='relative rounded-xl bg-blue-700 flex justify-center items-center cursor-pointer' onClick={() => navigate('/login')}>
            <span className="absolute inset-0 bg-blue-600 rounded-md blur-xl opacity-70 transition duration-300"></span>
            <p className='relative m-3 text-white'>Login</p>
          </button>
        </div>
       </div>
      </div>

      <div className='h-[75vh] flex justify-center items-center bg-[radial-gradient(circle_980px_at_40%_-33%,_#031457,_#000000)] mb-12'>
        <div className="absolute inset-0  bg-[url('./assets/framer/blur.png')] bg-no-repeat top-0 left-0 bg-[1500px_auto]"/>
        <div className="absolute inset-0  bg-[url('./assets/framer/Grid.png')] bg-no-repeat bg-top bg-[1800px_auto]"/>
 
        <div className='justify-center flex flex-col items-center w-[45%] text-center font-bold mt-6'>
          <p className='m-6 text-[65px] text-[#E6ECFF] leading-tight'>The ultimate platform to test, break and improve your AI</p>
          <p className='m-5 text-gray-400 text-xl'>All-in-one testing for LLM's - from strategy for failure reports, in one place.</p>
          <div className='flex flex-row gap-0 justify-center items-center'>
            <button className='relative rounded-xl bg-blue-700 border-blue-100 border-1 flex justify-center items-center m-6 cursor-pointer' onClick={() => navigate('/login')}>
              <span className="absolute inset-0 bg-blue-600 rounded-md blur-lg opacity-70 transition duration-300"></span>
              <p className='relative m-3'>Start testing now</p>
            </button>
            {/* <button className='relative rounded-xl bg-[#131e94] flex justify-center m-6 items-center cursor-pointer'><p className=' m-3'>View Sample Report</p></button> */}
          </div>
        </div>
      </div>


      <div className='flex flex-col justify-center items-center gap-12'> {/*card styles*/}
        <div className='w-[65%] rounded-xl flex flex-row  border-t-1  border-[#354887]  bg-[radial-gradient(circle_1100px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
          <div className='m-9 mt-20 w-[20vw]'>
            <p className=' font-bold text-3xl '>Advanced AI Insights</p>
            <p className='mt-3 text-gray-300 text-md'>In-depth insights to help you understand your LLM's weaknesses and potential improvement areas</p>
          </div>

          <div className='ml-24 m-12'>
            <div className='bg-[#131117] rounded-xl border-2 border-[#232325] w-[15vw] '>
              <div className='bg-[#131117] flex flex-row justify-center items-center font-bold rounded-xl border border-[#232325] border-2 w-[10vw] m-3'>
                <img alt="" src={Logo} className='m-2'/>
                <p className='mr-2'>LLMINATE</p>
                <div className='bg-green-500 rounded-2xl h-3 w-3'/>
              </div>
            </div>
            <div className='bg-[#131117] rounded-xl border-2 border-[#232325] w-[30vw] -mt-2 -ml-5 '>
              <div className='grid grid-cols-2 m-3 gap-2'>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>AI model optimization</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>Multi-turn Testing</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>Security Testing</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>Single-turn Testing</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>Edge Case Testing</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
                <div className='flex flex-row items-center justify-between bg-[#18171e] rounded-xl'>
                  <p className='m-3'>AI Detector Evaluation</p>
                  <FaArrowTrendUp className='mr-3 text-blue-400'  />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className='flex flex-row w-[65%] gap-12'>
          <div className='flex flex-col border-t-1  border-[#354887] rounded-xl bg-[radial-gradient(circle_1100px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
            <div className='m-9'>
              <p className='font-bold text-3xl'>Optimize LLM with Data-Driven Insights</p>
              <p className='text-gray-300 text-md mt-3'>Your data-driven guide to improving LLM's and making informed decisions about their performance.</p>
            </div>
            <div className='flex flex-row items-center m-9 mt-0'>
              <div className='bg-[#131117] flex flex-col rounded-xl border-2 border-[#232325]'>
                <p className='m-3'>Track AI Performance </p>
                <div className='flex flex-row m-3 gap-3'>
                  <div className='flex flex-row border-1 border-blue-300 rounded-lg justify-center items-center'>
                    <GiNetworkBars className='m-2 mr-0 text-blue-300' />
                    <p className='m-1 text-xs'>Monthly Tests</p>
                  </div>  
                  <div className='flex flex-row border-1 border-blue-300 rounded-lg justify-center items-center'> 
                    <CiClock2 className='m-2 mr-0 text-blue-300'/>
                    <p className='m-1 text-xs'>Last 24 hours</p>
                  </div>
                </div>
                <img alt="" src={waves} className='h-auto'/>
                <div className='bg-[#131117] flex flex-row justify-center items-center font-bold rounded-xl border border-[#232325] border-2 w-[10vw] m-3'>
                  <img alt="" src={Logo} className='m-2'/>
                  <p className='mr-2'>LLMINATE</p>
                  <div className='bg-green-500 rounded-2xl h-3 w-3'/>
                </div>
              </div>
              <div className='flex flex-col bg-[#131117] -ml-10 mt-6 rounded-xl border-2 border-[#232325]'>
                <p className='m-3'>Test Coverage</p>
                <div className='flex flex-row items-center ml-3 mr-3 mb-1'>
                  <IoIosCheckbox className='text-white' />
                  <p className='text-gray-400'>Response Accuracy</p>
                </div>
                <div className='flex flex-row items-center ml-3 mr-3 mb-1'>
                  <IoIosCheckbox className='text-white' />
                  <p className='text-gray-400'>Failure Rate</p>
                </div>
                <div className='flex flex-row items-center ml-3 mr-3 mb-3'>
                  <IoIosCheckbox className='text-white' />
                  <p className='text-gray-400'>Actionable Insights</p>
                </div>
              </div>
            </div>
          </div>

          <div className='flex flex-col rounded-xl border-t-1  border-[#354887]  bg-[radial-gradient(circle_1100px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
            <div className='m-9'>
              <p className='font-bold text-3xl'>Boost LLM Performance</p>
              <p className='text-gray-300 text-md mt-3'>Enhance your LLM's performance with targeted testing strategies and continuous optimization.</p>
            
            </div>
            <div className='flex flex-col bg-[#131117] w-[20vw] m-9 mt-0 rounded-xl border-[#232325] border-2'>
              <div className='bg-[#18171e] m-3 mt-3 mb-3 flex flex-row items-center rounded-xl'>
                <GiNetworkBars className='m-2 text-blue-300'/>
                <p>Real-time Testing</p>
              </div>
              <div className='bg-[#18171e] m-3 mt-0 mb-3 flex flex-row items-center rounded-xl'>
                <CiClock2 className='m-2 text-blue-300'/>
                <p>Last 24 hours</p>
              </div>
              <div className='bg-[#18171e] m-3 mt-0 mb-3 flex flex-row items-center rounded-xl'>
                <ImLoop className='m-2 text-blue-300'/>
                <p>Continuous Improvement</p>
              </div>
              <div className='bg-[#131117] flex flex-row justify-center items-center font-bold rounded-xl border border-[#232325] border-2 w-[10vw] m-3'>
                <img alt="" src={Logo} className='m-3'/>
                <p className='mr-2'>LLMINATE</p>
                <div className='bg-green-500 rounded-2xl h-3 w-3'/>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className='relative mt-6 justify-center flex flex-col items-center  bg-[radial-gradient(circle_1600px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))]'>
        <div className=' h-2 w-full bg-[rgba(237, 235, 235, 0.1)] relative'/>
        <div className="absolute inset-0  bg-[url('./assets/framer/blur_vertical.png')] bg-no-repeat  bg-[1800px_auto]"/>
        <div className='flex flex-col justify-center items-center m-12 mt-28'>
          <div className='bg-black relative rounded-4xl border-l-5 border-blue-800'>
            <p className='m-3 text-xl text-blue-300 ml-5 mr-5'>BENEFITS</p>
          </div>
          <p className='m-5 text-4xl font-bold'>Why Choose Us?</p>
          <p className='text-lg text-gray-300 w-[25%] text-center text-wrap'>Innovative tools and powerful insights designed to elevate your business</p>


          <div className='w-[65%] grid grid-cols-3 mt-12 gap-6'>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image1} class="h-auto w-auto m-0" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Instant Insights</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>Get real-time feedback on your LLM's performance, highlighting issues, failures and improvement areas instantly</p>
            </div>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image2} class="h-auto w-auto m-0 border-2 blur-[1px] border-transparent" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Advanced AI Testing</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>Leverage in-depth, data-driven, insights into your LLM, helping you understand weaknesses and optimize performance</p>
            </div>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image3} class="h-auto w-auto m-0 border-2 blur-[1px] border-transparent" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Comprehensive Test Converage</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>Test your LLM's across detectors, edge cases, and real-world scenarios to ensure reliability.</p>
            </div>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image4} class="h-auto w-auto m-0" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Tailored Strategies</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>Run tests with specific configurations, strategies, and goals — all in one integrated platform.</p>
            </div>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image5} class="h-auto w-auto m-0" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Use-Case Testing</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>AI-driven testing across real-world scenarios with 40+ detectors, generating thousands of test cases.</p>
            </div>
            <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
              <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                <img alt="" src={image6} class="h-auto w-auto m-0" />
              </div>
              <p className='ml-6 font-bold text-2xl'>Security Analysis and Reporting</p>
              <p className='m-6 text-gray-300 mt-3 mb-12'>Framework-based security analysis with clear, actionable reports to identify and resolve vulnerabilities.</p>
            </div>
          </div>
        </div>

        <div className="px-10 py-10 bg-transparent w-[65%] overflow-x-hidden">
          <div className="relative overflow-hidden h-[60px] mb-4">
            <div className="flex items-center whitespace-nowrap gap-4 h-full animate-left">
              <div className="flex gap-4 shrink-0">
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Fault Detection</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Real-Time Testing</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Continuous Optimization</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Improvement Analytics</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">LLM Behavior Insights</span>
              </div>
              <div className="flex gap-4 shrink-0">
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Fault Detection</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Real-Time Testing</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Continuous Optimization</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Improvement Analytics</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">LLM Behavior Insights</span>
              </div>
            </div>
          </div>

          <div className="relative overflow-hidden h-[60px] mb-4">
            <div className="flex items-center whitespace-nowrap gap-4 h-full animate-right">
              <div className="flex gap-4 shrink-0">
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Smart Test Strategies</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Failure Insights</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Precision Testing</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Real-World Scenarios</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Edge Case Reporting</span>
              </div>
              <div className="flex gap-4 shrink-0">
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Smart Test Strategies</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Failure Insights</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Precision Testing</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Real-World Scenarios</span>
                <span className="px-4 py-2 rounded-full bg-black/60 text-white text-sm font-medium backdrop-blur">Edge Case Reporting</span>
              </div>
            </div>
          </div>

          <style>
            {`
              .animate-left {
                animation: scrollLeftToRight 15s linear infinite;
              }
              .animate-right {
                animation: scrollRightToLeft 15s linear infinite;
              }
              @keyframes scrollLeftToRight {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
              @keyframes scrollRightToLeft {
                0% { transform: translateX(-50%); }
                100% { transform: translateX(0); }
              }
            `}
          </style>
        </div>
      </div>

      <div className='flex flex-col justify-center items-center'>
        <div className=' flex flex-col justify-center items-center m-12 mt-28'>
            <div className='bg-black relative rounded-4xl border-l-5 border-blue-800'>
              <p className='m-3 text-xl text-blue-300 ml-5 mr-5'>COMPARISON</p>
            </div>
            <p className='text-4xl font-bold mt-9 text-white'>Why LLMinate Stands Out</p>
            <p className='text-gray-300 mt-3'>See how we compare against others in performance and growth</p>
        </div>
        <div className='w-[55%] grid grid-cols-2 mt-5 gap-4 mb-12'>
          <div className='flex flex-col justify-center items-center'>
            <p className='font-bold text-2xl m-3'>LLMINATE</p>
            <div className='flex flex-col border-t-1 border-[#354887] rounded-xl bg-[radial-gradient(circle_1100px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              {[
                "Comprehensive, real-world scenario testing",
                "Data-driven insights for performance optimization",
                "Customizable dashboards & seamless integration",
                "Advanced collaboration and detailed reporting",
                "40+ detectors, generating thousands of test cases"
              ].map((item, idx) => (
                <div key={idx}>
                  <div className='m-6 mb-1 flex flex-row justify-start items-center gap-3'>
                    <SiTicktick />
                    <p>{item}</p>
                  </div>
                  {idx < 4 && <div className='border-blue-300 border-1 mb-3 mt-3 mx-9' />}
                  {idx === 4 && <div className='mb-6'/>}
                </div>
              ))}
            </div>
          </div>

          <div className='flex flex-col justify-center items-center'>
            <p className='font-bold text-2xl m-3'>Others</p>
            <div className='flex flex-col border-t-1 mb-3 border-[#354887] rounded-xl bg-[radial-gradient(circle_1100px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
              {[
                "Focused on security or LLM testing",
                "Basic or limited analytics",
                "Limited customization options",
                "Fewer collaboration features and actionable insights",
                "Fewer detectors and limited test cases"
              ].map((item, idx) => (
                <div key={idx} >
                  <div className='m-6 mb-1 flex flex-row justify-start items-center gap-3'>
                    <HiX />
                    <p>{item}</p>
                  </div>
                  {idx < 4 && <div className='border-blue-300 border-1 mb-3 mt-3 mx-9' />}
                  {idx === 4 && <div className='mb-6'/>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>


      <div className='relative mt-6 justify-center flex flex-col items-center  bg-[radial-gradient(circle_1600px_at_50%_-110%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))]'>
        <style>
          {`
            @keyframes rotate{
              from{
                transform: rotate(0deg);
              }
              to{
                transform: rotate(360deg);
              }
            }
          `}
          
        </style>
        {/* <div className=' h-2 w-full bg-[rgba(237, 235, 235, 0.1)] relative'/> */}
        <div className="absolute inset-0  bg-[url('./assets/framer/blur_vertical.png')] bg-no-repeat  bg-[1800px_auto]"/>
        <div className='absolute inset-0 flex justify-center items-center overflow-hidden'>
          <div className="absolute justify-center items-center inset-0 m-6 bg-[url('./assets/framer/radar.png')] bg-no-repeat bg-center mt-20 bg-[800px_auto]"
            style={{animation: 'rotate 8s linear infinite'}}
          />
        </div>
        <div className='relative flex flex-col justify-center items-center m-12 mt-[25vh]'>
          <div className='bg-black relative rounded-4xl border-l-5 border-blue-800'>
            <p className='m-3 text-xl text-blue-300 ml-5 mr-5'>AI-DRIVEN EFFICIENCY</p>
          </div>
          <p className='relative text-4xl font-bold mt-9 text-white'>Crush Trends. Lead the Pack.</p>
          <p className='relative w-[18vw] bg-black opacity-90 m-3 rounded-xl  text-wrap text-center text-gray-300 mt-6'>Dominate the AI game with real-time insights and unstoppable optimization</p>
          <div className='bg-black relative w-[65%] rounded-xl mt-6 justify-center items-center flex flex-col'>
            <div className='grid grid-cols-3 gap-6 mt-8'>
              <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
                <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
                <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                  <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                  <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                  <img alt="" src={image1} class="h-auto w-auto m-0" />
                </div>
                <p className='ml-6 font-bold text-2xl'>Seamless Integration and Support</p>
                <p className='m-6 text-gray-300 mt-3 mb-12'>Your data is synced in real-time across devices, ensuring you stay connected and informed—online or offline.</p>
              </div>
              <div className='relative flex flex-col justify-center rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
                <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
                <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                  <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                  <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                  <img alt="" src={image1} class="h-auto w-auto m-0" />
                </div>
                <p className='ml-6 font-bold text-2xl'>Ironclad Security and Scalability</p>
                <p className='m-6 text-gray-300 mt-3 mb-12'>Enterprise-grade encryption protects your information, while flexible tools adapt to your business needs.	</p>
              </div>
              <div className='relative flex flex-col justify-start rounded-xl  border-t-1  border-[#354887]  bg-[radial-gradient(circle_715px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden'>
                <div className='absolute top-0 left-0 h-6 w-auto bg-red-500 border-transparent'></div>
                <div class="relative w-15 h-15 bg-[#100a0c] rounded-xl flex items-center justify-center m-6">
                  <div class="absolute top-0 left-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-l-1 border-t-1"></div>
                  <div class="absolute bottom-0 right-0 w-5 h-5 border-[#5d75ff] rounded-[4px]   border-b-1 border-r-1"></div>
                  <img alt="" src={image1} class="h-auto w-auto m-0" />
                </div>
                <p className='ml-6 font-bold text-2xl'>Insight Driven Optimization</p>
                <p className='m-6 text-gray-300 mt-3 mb-12'>Leverage AI-powered analytics to identify trends, predict outcomes, and optimize your workflow effortlessly.</p>
              </div>
            </div>
            <div className='flex justify-center items-center gap-6 mb-12 text-white py-4'>
              <div className='flex items-center gap-2 px-4 border-r border-gray-600'>
                <TrendingUp className='text-blue-400 text-xl' />
                <p className='text-sm text-blue-100'>Smart Analytics</p>
              </div>
              <div className='flex items-center gap-2 px-4 border-r border-gray-600'>
                <Users className='text-blue-400 text-xl' />
                <p className='text-sm text-blue-100'>Real-Time Collaboration</p>
              </div>
              <div className='flex items-center gap-2 px-4 '>
                <CheckSquare className='text-blue-400 text-xl' />
                <p className='text-sm text-blue-100'>Task Prioritization</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className='relative mt-6 justify-center flex flex-col items-center'>
        <div className=' h-2 w-full bg-[rgba(237, 235, 235, 0.1)] relative'/>
        <div className="absolute inset-0  bg-[url('./assets/framer/blur_vertical.png')] bg-no-repeat  bg-[2000px_auto]"/>
        <div className='flex flex-col justify-center items-center m-12 mt-28'>
          <div className='bg-black relative rounded-4xl border-l-5 border-blue-800'>
            <p className='m-3 text-xl text-blue-300 ml-5 mr-5'>FAQ'S SECTION</p>
          </div>
          <p className='text-4xl font-bold mt-9 text-white'>Some Common FAQ's</p>
          <p className='text-gray-300 mt-3'>Get answers to your questions and learn about our platform</p>
          <div className='flex flex-col w-[65%] mt-12 gap-6'>
            {faqData.map((item, index) => (
                <div 
                  key={index}
                  className='relative flex flex-col justify-center rounded-xl border-t-1 border-[#354887] bg-[radial-gradient(circle_715px_at_50%_-180%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] overflow-hidden transition-all duration-300 ease-in-out'
                >
                  <div 
                    className='flex justify-between items-center cursor-pointer p-6'
                    onClick={() => toggleItem(index)}
                  >
                    <p className='text-xl text-white'>{item.question}</p>
                    <div className='flex-shrink-0 ml-4'>
                      {openItems[index] ? (
                        <ChevronUp className='w-6 h-6 text-white transition-transform duration-300' />
                      ) : (
                        <ChevronDown className='w-6 h-6 text-white transition-transform duration-300' />
                      )}
                    </div>
                  </div>
                  
                  <div 
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${
                      openItems[index] ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className='px-6 pb-6'>
                      <p className='text-gray-300 text-lg leading-relaxed'>
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>


      <div className='relative mt-6 justify-center flex flex-col items-center bg-[radial-gradient(circle_1600px_at_50%_-130%,_rgba(33,55,117,0.7),_rgba(0,0,0,0.9))] pb-0'>
        <div className='h-2 w-full bg-[rgba(237, 235, 235, 0.1)] relative'/>
        <div className="absolute inset-0 bg-[url('./assets/framer/blur_vertical.png')] bg-no-repeat bg-[2000px_auto]" />

        <div className='flex flex-col justify-center items-center m-12 mt-28'>
          <div className='bg-black relative rounded-4xl border-l-5 border-blue-800'>
            <p className='m-3 text-xl text-blue-300 ml-5 mr-5'>WHAT ARE YOU WAITING FOR</p>
          </div>
          <p className='text-4xl font-bold mt-9 text-white'>Get Started with LLMINATE</p>
          <p className='text-gray-300 mt-3'>Optimize your LLMs with powerful testing and actionable insights.</p>

          <div className='flex flex-row gap-0 justify-center items-center'>
            <button className='relative rounded-xl bg-blue-700 border-blue-100 border-1 flex justify-center items-center m-6 cursor-pointer' onClick={() => navigate('/login')}>
              <span className="absolute inset-0 bg-blue-600 rounded-md blur-lg opacity-70 transition duration-300"></span>
              <p className='relative m-3'>Get Started now</p>
            </button>
          </div>

          {/* Dashboard image with absolute positioning - full screen coverage */}
          <div className="absolute top-[400px] left-1/2 transform -translate-x-1/2 w-[1400px] h-[700px] bg-[url('./assets/framer/Dashboard.png')] bg-no-repeat bg-center bg-contain" />
        </div>

        {/* Footer Section */}
        <footer className='w-full mt-[387px] h-[32vh] bg-black/20 backdrop-blur-sm border-t border-gray-800'>
          <div className='max-w-7xl mx-auto px-8 py-12'>
            {/* Single horizontal row with all sections */}
            <div className='flex flex-row justify-between items-start'>
              {/* Logo Section */}
              <div>
                <h2 className='text-2xl font-bold text-white'>LLMINATE</h2>
              </div>

              {/* Navigation Links in horizontal layout */}
              <div className='flex flex-row gap-16'>
                <Link 
                  to="/privacy-policy"
                  className="group relative"
                >
                  <h3 className='text-white font-semibold transition-all duration-300 group-hover:text-blue-400'>
                    Privacy Policy
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                  </h3>
                </Link>
                
                <Link 
                  to="/contact"
                  className="group relative"
                >
                  <h3 className='text-white font-semibold transition-all duration-300 group-hover:text-blue-400'>
                    Contact
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                  </h3>
                </Link>
                
                <Link 
                  to="/about"
                  className="group relative"
                >
                  <h3 className='text-white font-semibold transition-all duration-300 group-hover:text-blue-400'>
                    About Us
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                  </h3>
                </Link>
              </div>

              {/* Right side buttons */}
              <div className='flex gap-4'>
                <button className='bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors' onClick={() => navigate('/login')}>
                  Login
                </button>
              </div>
            </div>

            {/* Copyright at bottom */}
            <div className='mt-8 pt-8 border-t border-gray-800'>
              <div className='text-gray-400 text-sm'>
                © 2025 — Copyright
              </div>
            </div>
          </div>
        </footer>
      </div>


    </div>
  )
}

export default LandingPage
